import { render } from "./MyConsumptions.vue?vue&type=template&id=cdbec624&scoped=true"
import script from "./MyConsumptions.vue?vue&type=script&lang=js"
export * from "./MyConsumptions.vue?vue&type=script&lang=js"

import "./MyConsumptions.vue?vue&type=style&index=0&id=cdbec624&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdbec624"]])

export default __exports__